import React, { useState } from 'react';
import "./css/concursos.css";

import solucionesConcurso1oifem1 from "./assets/files/oifem1/clasificatorio.pdf";
import oifem1Practica1 from "./assets/files/oifem1/practica1.pdf";
import oifem1Practica2 from "./assets/files/oifem1/practica2.pdf";
import oifem1Practica3 from "./assets/files/oifem1/practica3.pdf";
import oifem1Practica4Nivel1 from "./assets/files/oifem1/practica4Nivel1.pdf";
import oifemFinal1 from "./assets/files/oifem1/final1.pdf";
import oifemFinal2 from "./assets/files/oifem1/final2.pdf";

export default function Concursos() {
    const [concursoSeleccionado, setConcursoSeleccionado] = useState("todos");
    const [edicion, setEdicion] = useState("todos");

    const oifem2021 = [
        {
            nombre: "Concurso clasificatorio OIFem I (28/02/21)",
            problemas: [
                { url: "https://www.hackerrank.com/oifem-2021-clasificatorio", nombre: "Problemas" }
            ],
            soluciones: [
                {url: solucionesConcurso1oifem1, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Concurso de práctica I (07/03/21)",
            problemas: [
                {url: "https://omegaup.com/arena/problem/Moda-GCF/", nombre: "Moda GCF"},
                {url: "https://omegaup.com/arena/problem/Secuencias-saltarinas/", nombre: "Secuencias saltarinas"},
                {url: "https://omegaup.com/arena/problem/Promedios-en-intervalos/", nombre: "Promedios en intervalos"},
                {url: "https://omegaup.com/arena/problem/omi_2019_balanceado/", nombre: "Perfectamente balanceado"},
                {url: "https://omegaup.com/arena/problem/ciic2020-horario/", nombre: "Eligiendo el horario"},
                {url: "https://omegaup.com/arena/problem/Plantas-Extranas/", nombre: "Plantas extrañas"}
            ],
            soluciones: [
                {url: oifem1Practica1, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Final Día 1- OIFem I (20/03/21)",
            problemas: [
                {url: "https://www.hackerrank.com/oifem-2021-final-dia1", nombre: "Problemas"}
            ],
            soluciones: [
                {url: oifemFinal1, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Final Día 2- OIFem I (21/03/21)",
            problemas: [
                {url: "https://www.hackerrank.com/oifem-2021-final-dia-2", nombre: "Problemas"}
            ],
            soluciones: [
                {url: oifemFinal2, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Concurso de práctica II (25/04/21)",
            problemas: [
                {url: "https://omegaup.com/arena/problem/Tienda-de-telefonos/#problems", nombre: "Tienda de teléfonos"},
                {url: "https://omegaup.com/arena/problem/Adulto/#problems", nombre: "Adulto"},
                {url: "https://omegaup.com/arena/problem/Watermel/#problems", nombre: "Watermelon"},
                {url: "https://omegaup.com/arena/problem/abc/", nombre: "ABC"},
                {url: "https://omegaup.com/arena/problem/El-ladron-precavido/", nombre: "El ladrón precavido"},
                {url: "https://omegaup.com/arena/problem/IOI-1994---El-Castillo/", nombre:"El castillo"},
                {url: "https://omegaup.com/arena/problem/Chocolates-CIIC-2015/", nombre: "Chocolates"},
                {url: "https://omegaup.com/arena/problem/androides/", nombre: "Androides"},
                {url: "https://omegaup.com/arena/problem/Donaciones-CIIC-2015/", nombre: "Donaciones"},
                {url: "https://omegaup.com/arena/problem/CIIC2018-Juego/", nombre: "Juego"}
            ],
            soluciones: [
                {url: oifem1Practica2, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Concurso de práctica III (23/05/21)",
            problemas: [
                {url: "https://omegaup.com/arena/problem/Comparando-numero-de-galaxias/",  nombre: "Comparando número de galaxias"},
                {url: "https://omegaup.com/arena/problem/Dos-gatos-y-un-raton/", nombre: "Dos gatos y un ratón"},
                {url: "https://omegaup.com/arena/problem/MDUI-UAMA/", nombre: "Múltiplos dentro de un intervalo"},
                {url: "https://omegaup.com/arena/problem/Nombres-y-apellidos-sanos/", nombre: "Nombres y apellidos sanos"},
                {url: "https://omegaup.com/arena/problem/Minimo-comun-multiplo-de-varios-/", nombre: "Mínimo común múltiplo de varios enteros"},
                {url: "https://omegaup.com/arena/problem/Xornacci-cpp/", nombre: "Xornacci"},
                {url: "https://omegaup.com/arena/problem/atsa-copa-fut/", nombre: "Atsa y el torneo de programación"},
                {url: "https://omegaup.com/arena/problem/Contando-secuencias-crecientes/", nombre: "Contando secuencias crecientes"},
                {url: "https://omegaup.com/arena/problem/Pies-de-hobbits/", nombre: "Pies de hobbits"},
                {url: "https://omegaup.com/arena/problem/Contando-Estudiantes/", nombre: "Contando estudiantes"}
            ],
            soluciones: [
                {url: oifem1Practica3, nombre: "Soluciones"}
            ]
        },
        {
            nombre: "Concurso de práctica IV - nivel I (27/11/21)",
            problemas: [
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/aprendiendo-a-contar", nombre: "Aprendiendo a contar"},
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/hola-permutacion", nombre: "¡Hola!"},
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/konnichiwa-oie-2018", nombre: "Konnichiwa OIE 2018"},
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/lomo-queso", nombre: "Lomo queso"},
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/palabras-abcd", nombre: "Palabras abcd"},
                {url: "https://www.hackerrank.com/contests/oifem-ii-concurso-de-practica-1-nivel-1/challenges/numeros-vecinos", nombre: "Números vecinos"}
            ],
            soluciones: [
                {url: oifem1Practica4Nivel1, nombre: "Soluciones"}
            ]
        }
    ];

    const oifem2022 = [
    ];


    const egoi2021 = [];

    return (
        <div id="concursos">
            <div className='destacado'>
                <h2>Concursos</h2>
                <p>
                    En esta sección encontrarás un histórico con todos los concursos organizados por la OIFem, incluidos los de práctica, con soluciones comentadas, además de soluciones 
                    creadas por nuestra organización a los problemas de todas las EGOIs.
                </p>
            </div>

            <div className="sticky">
                <div>
                    <label htmlFor='concurso'>Concurso</label>
                    <select id="concurso" value={concursoSeleccionado} onChange={(e) => setConcursoSeleccionado(e.target.value)}>
                        <option value="todos">Todos</option>
                        <option value="oifem">OIFem</option>
                        <option value="egoi">EGOI</option>
                    </select>
                </div>
                
                <div>
                    <label htmlFor='anio'>Año</label>
                    <select id="anio" value={edicion} onChange={(e) => setEdicion(e.target.value)}>
                        <option value="todos">Todos</option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option>
                        {/* <option value="2023">2023</option>
                        <option value="2024">2024</option> */}
                    </select>
                </div>
            </div>

            {(concursoSeleccionado === "todos" || concursoSeleccionado === "oifem") && (
                <div>
                    <h3>OIFem</h3>
                    
                    {(edicion === "todos" || edicion === "2021") && (
                        <div>
                            <h4>2021</h4>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Concurso</th>
                                        <th>Problemas</th>
                                        <th>Soluciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {oifem2021.map((concurso, index) => (
                                        <tr key={index}>
                                            <td>{concurso.nombre}</td>
                                            <td>
                                                {concurso.problemas.map((problema, i) => (
                                                    <div>
                                                        <a key={i} href={problema.url} target="_blank" rel="noopener noreferrer">
                                                            {problema.nombre}
                                                        </a>
                                                    </div>
                                                ))}
                                            </td>
                                            <td>
                                                {concurso.soluciones.map((solucion, i) => (
                                                    <a key={i} href={solucion.url} target="_blank" rel="noopener noreferrer">
                                                        {solucion.nombre}
                                                    </a>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {(edicion === "todos" || edicion === "2022") && (
                        <div>
                            <h4>2022</h4>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Concurso</th>
                                        <th>Problemas</th>
                                        <th>Soluciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {oifem2022.map((concurso, index) => (
                                        <tr key={index}>
                                            <td>{concurso.nombre}</td>
                                            <td>
                                                {concurso.problemas.map((problema, i) => (
                                                    <a key={i} href={problema.url} target="_blank" rel="noopener noreferrer">
                                                        {problema.nombre}
                                                    </a>
                                                ))}
                                            </td>
                                            <td>
                                                {concurso.soluciones.map((solucion, i) => (
                                                    <a key={i} href={solucion.url} target="_blank" rel="noopener noreferrer">
                                                        {solucion.nombre}
                                                    </a>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}

            {(concursoSeleccionado === "todos" || concursoSeleccionado === "egoi") && (
                <div>
                    <h3>EGOI</h3>
                    
                    {(edicion === "todos" || edicion === "2021") && (
                        <div>
                            <h4>2021</h4>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Concurso</th>
                                        <th>Problemas</th>
                                        <th>Soluciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {egoi2021.map((concurso, index) => (
                                        <tr key={index}>
                                            <td>{concurso.nombre}</td>
                                            <td>
                                                {concurso.problemas.map((problema, i) => (
                                                    <div>
                                                        <a key={i} href={problema.url} target="_blank" rel="noopener noreferrer">
                                                            {problema.nombre}
                                                        </a>
                                                    </div>
                                                ))}
                                            </td>
                                            <td>
                                                {concurso.soluciones.map((solucion, i) => (
                                                    <a key={i} href={solucion.url} target="_blank" rel="noopener noreferrer">
                                                        {solucion.nombre}
                                                    </a>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
